import useSWR from 'swr'
import fetcher from '../../utils/fetcher'
import { ResponseData } from './types'

interface CitiesResponse {
  jobs: Array<{id: string, name: string}>
  interview: Array<{id: string, name: string}>
}

export default function useFetchCities() {
  const res = useSWR<ResponseData<CitiesResponse>>('/content.php?a=city', fetcher.get)

  return res
}